import type { BrowserClient, feedbackIntegration } from "@sentry/sveltekit";
import * as Sentry from "@sentry/sveltekit";

export function reportBug(id = "", email = "", name = "") {
    try {
        Sentry.setUser({ id: id, email: email, name: name });
        Sentry.getClient<BrowserClient>()
            ?.getIntegrationByName<ReturnType<typeof feedbackIntegration>>("Feedback")
            ?.openDialog();
    } catch (e) {
        Sentry.captureException(e);
        throw e;
    }
    return "";
}
